import { FfsPart } from 'features/indicationTriage/cards/ffsCalc/ffsResultPublish/ffsTypes'
import { FfsPartStep } from 'features/libra/stepComponents/ffs/FfsPartStep'
import { LibraWorflowStepComponentProps } from 'features/libra/workflow/workflowStepsApi'
import { FC } from 'react'

/**
 * FFS Part 5 (local metal loss) workflow step. Thin wrapper binding the shared
 * `FfsPartStep` core to `FfsPart.PART_5`.
 */
export const Component: FC<
  LibraWorflowStepComponentProps<Record<string, never>>
> = ({ readonly = false }) => (
  <FfsPartStep ffsPart={FfsPart.PART_5} readonly={readonly} />
)
